import { Browser } from "@capacitor/browser";

import { isNative } from "~/lib/capacitor";

/**
 * Open a URL that belongs to somebody else.
 *
 * Navigating the WebView itself would be the worst outcome on a phone: the app has no
 * browser chrome, so a member who followed a livestream link would be stranded on a
 * third-party page with no back button and no way out but killing the app.
 *
 * - **Native** — the in-app browser (SFSafariViewController / Custom Tabs). It keeps the
 *   member inside the app, shows the real origin, and has its own Done button.
 * - **Web** — a new tab, with `noopener` so the opened page cannot reach back through
 *   `window.opener`.
 */
export async function openExternal(url: string): Promise<void> {
  if (isNative()) {
    await Browser.open({ url });
    return;
  }
  window.open(url, "_blank", "noopener,noreferrer");
}
